import { TabContext, TabList, TabPanel } from "@mui/lab";
import { Box, Stack, Tab, Typography } from "@mui/material";
import type { FC } from "react";
import { useState } from "react";
import Phone from "../../components/links/Phone";
import type { ParticipantListRequiredFields, ParticipantListResponse } from "./participantListApi";
import ReadonlyParticipantListCombination from "./ReadonlyParticipantListCombination";

const defaultRequiredFields: ParticipantListRequiredFields = {
  gender: true,
  dateOfBirth: true,
  citizenship: true,
  documentNumber: true,
  documentExpiryDate: true,
};

interface Props {
  readonly participantList: ParticipantListResponse;
  readonly previousParticipantList: ParticipantListResponse | undefined;
  readonly requiredFields: ParticipantListRequiredFields | undefined;
  readonly showDiffs: boolean;
}

const ParticipantListReadonlyPanel: FC<Props> = ({
  participantList,
  previousParticipantList,
  requiredFields,
  showDiffs,
}) => {
  const [combinationIdx, setCombinationIdx] = useState("0");
  const resolvedRequiredFields = requiredFields ?? defaultRequiredFields;

  return (
    <>
      <TabContext value={combinationIdx}>
        <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
          <TabList onChange={(_, newValue) => setCombinationIdx(newValue)} aria-label="Kombinacje listy osób">
            {participantList.combinations.map((_, idx) => (
              <Tab key={idx} label={`Układ ${idx + 1}`} value={`${idx}`} />
            ))}
          </TabList>
        </Box>
        {participantList.combinations.map((c, idx) => (
          <TabPanel value={`${idx}`} key={idx} sx={{ minHeight: "400px" }}>
            {combinationIdx === `${idx}` && (
              <ReadonlyParticipantListCombination
                combination={c}
                previousCombination={previousParticipantList ? previousParticipantList.combinations[idx] : undefined}
                showDiffs={showDiffs}
                requiredFields={resolvedRequiredFields}
              />
            )}
          </TabPanel>
        ))}
      </TabContext>
      <Stack
        direction="row"
        spacing={4}
        sx={{
          marginLeft: 3,
          marginTop: 2,
        }}
      >
        <Stack direction="column">
          <Typography variant="subtitle2">Tour leader phone</Typography>
          {participantList.tourLeader.tourLeaderPhone ? (
            <Phone value={participantList.tourLeader.tourLeaderPhone} />
          ) : (
            <Typography>n.d.</Typography>
          )}
        </Stack>
        {participantList.bus ? (
          <Stack direction="column">
            <Typography variant="subtitle2">Bus plate number</Typography>
            <Typography>{participantList.bus.plateNumber}</Typography>
          </Stack>
        ) : null}
        {participantList.bus ? (
          <Stack direction="column">
            <Typography variant="subtitle2">Driver phone</Typography>
            {participantList.bus.driverPhone ? (
              <Phone value={participantList.bus.driverPhone} />
            ) : (
              <Typography>n.d.</Typography>
            )}
          </Stack>
        ) : null}
      </Stack>
    </>
  );
};

export default ParticipantListReadonlyPanel;
